// ===== 1. تابع کمکی: گرفتن مقدار از selectedValue =====
function getFieldValue(field) {
    if (!field || field.visible === false) return '';

    if (field.selectedValue === '' || field.selectedValue === null || field.selectedValue === undefined) {
        return '';
    }

    if (typeof field.selectedValue === 'object') {
        if (Object.keys(field.selectedValue).length === 0) {
            return '';
        }

        return field.selectedValue.id?.toString() ||
            field.selectedValue.code?.toString() ||
            field.selectedValue.value?.toString() ||
            '';
    }

    return field.selectedValue.toString();
}

// ===== 2. بررسی یک شرط =====
function checkSingleCondition(fields, condition) {
    const { fieldId, operatorId, valueId, value } = condition;

    const sourceField = fields.find(f => f.id.toString() === fieldId.toString());
    if (!sourceField) return false;

    const sourceValue = getFieldValue(sourceField);

    const conditionValue =
        valueId !== null && valueId !== undefined
            ? valueId.toString()
            : value;

    switch (operatorId) {
        case 1:
            return sourceValue === conditionValue;

        case 2:
            return sourceValue !== conditionValue;

        case 7:
            if (typeof sourceField.selectedValue === 'object') {
                return sourceField.selectedValue &&
                    Object.keys(sourceField.selectedValue).length > 0;
            }
            return sourceValue !== '';

        case 8:
            if (typeof sourceField.selectedValue === 'object') {
                return !sourceField.selectedValue ||
                    Object.keys(sourceField.selectedValue).length === 0;
            }
            return sourceValue === '';

        default:
            return false;
    }
}

// ===== 3. بررسی همه شرط‌ها (OR) =====
function checkAllConditions(fields, conditionalFields) {
    if (!conditionalFields || conditionalFields.length === 0) return false;

    for (const condition of conditionalFields) {
        if (checkSingleCondition(fields, condition)) {
            return true;
        }
    }

    return false;
}

// ===== 4. آپدیت فیلدهای شرطی (نسخه اصلاح شده برای زنجیره وابستگی) =====
function updateConditionalRequiredFields(allFields) {
    // ایجاد یک کپی عمیق از فیلدها برای تغییرات
    const updatedFields = JSON.parse(JSON.stringify(allFields));

    updatedFields.forEach(field => {

        // حالت فیلد شرطی
        if (field.conditionalRequired === true &&
            field.conditionalFields &&
            field.conditionalFields.length > 0) {

            // بررسی شرط
            const conditionMet = checkAllConditions(updatedFields, field.conditionalFields);

            if (conditionMet) {
                field.required = true;
                field.visible = true;
            } else {
                field.required = false;
                field.visible = false;
                // --- نکته کلیدی: پاک کردن مقدار فیلد وقتی مخفی می‌شود ---
                field.selectedValue = ''; 
            }
        }
        // فیلد همیشه اجباری
        else if (field.required === true && field.conditionalRequired === false) {
            field.required = true;
            field.visible = true;
        }
        // فیلد اختیاری
        else {
            field.visible = true;
        }
    });

    return updatedFields;
}


// ===== 5. تغییر مقدار فیلد =====
function handleFieldChange(allFields, changedFieldId, newValue) {

    let updatedFields = allFields.map(field => {

        if (field.id.toString() === changedFieldId.toString()) {

            const updatedField = { ...field };

            if (field.type === 'radio') {

                if (!newValue) {
                    updatedField.selectedValue = '';
                }

                else if (typeof newValue === 'string' || typeof newValue === 'number') {

                    const options = field.fields || [];

                    const option = options.find(
                        opt => opt.id.toString() === newValue.toString()
                    );

                    updatedField.selectedValue = option || newValue;
                }

                else if (typeof newValue === 'object') {
                    updatedField.selectedValue = newValue;
                }

            } else {
                updatedField.selectedValue = newValue;
            }

            return updatedField;
        }

        return field;
    });

    updatedFields = updateConditionalRequiredFields(updatedFields);

    return updatedFields;
}

// ===== 6. مقداردهی اولیه =====
function initializeConditionalFields(allFields) {

    const fields = allFields.map(field => {

        const newField = { ...field };

        // مقدار اولیه visibility
        if (field.conditionalRequired === true) {
            newField.visible = false;
            newField.required = false;
        } else {
            newField.visible = true;
        }

        return newField;
    });

    return updateConditionalRequiredFields(fields);
}

export {
    getFieldValue,
    checkSingleCondition,
    checkAllConditions,
    updateConditionalRequiredFields,
    handleFieldChange,
    initializeConditionalFields
};

